import {useState} from "react";
import useMerchantPortalAxios, {useMerchantPortalFormData} from "../utils/axios";

const MerchantEnrollmentAPI = () => {
    const [autofillData, setAutofillData] = useState(null);
    const [employeesList, setEmployeesList] = useState(null);
    const [uploadLoading, setUploadLoading] = useState(false);
    const [categoriesList, setCategoriesList] = useState(null);
    const [subCategoriesList, setSubCategoriesList] = useState(null);
    const [districtsList, setDistrictsList] = useState(null);
    const [citiesList, setCitiesList] = useState(null);
    const [webProvidersList, setWebProvidersList] = useState(null);
    const [response, setResponse] = useState(null);

    const MerchantPortalAxios = useMerchantPortalAxios();
    const MerchantPortalAxisFormData = useMerchantPortalFormData();

    const CorporateAutoFillData = async () => {
        const res = await MerchantPortalAxios.post(
            '/v1/MerchantEnrollment/CorporateAutoFillData',
            {
                Code: sessionStorage.getItem("RegCodUrl"),
                SessionID: sessionStorage.getItem("SessionID")
            }
        );

        setAutofillData(res.data.Payload);
    }

    const GetEmployeeNames = async (EmployeeListInfo) => {
        const res = await MerchantPortalAxios.post(
            '/v1/MerchantEnrollment/GetEmployeeNames',
            {
                SessionID: sessionStorage.getItem("SessionID"),
                EmployeeListInfo
            }

        );

        setEmployeesList(res.data.Payload);
    }

    const SaveCorporateEnrollmentData = async (payload) => {
        setUploadLoading(true);
        const res = await MerchantPortalAxios.post(
            '/v1/MerchantEnrollment/SaveCorporateEnrollmentData',
            {
                SessionID: sessionStorage.getItem("SessionID"),
                payload
            }
        ).then(() => {
            setUploadLoading(false);
        });

        return res.data.Payload;
    }

    const GetCategories = async () => {
        const res = await MerchantPortalAxios.get(
            '/v1/MerchantEnrollment/GetCategories'
        );

        setCategoriesList(res.data);
    }

    const GetSubCategories = async (CategoryID) => {
        const res = await MerchantPortalAxios.post(
            '/v1/MerchantEnrollment/GetSubCategories',
            {
                CategoryID
            }
        );

        setSubCategoriesList(res.data);
    }

    const GetDistricts = async () => {
        const res = await MerchantPortalAxios.get(
            '/v1/MerchantEnrollment/GetDistricts',
        );

        setDistrictsList(res.data);
    }

    const GetCities = async (DistrictID) => {
        const res = await MerchantPortalAxios.post(
            '/v1/MerchantEnrollment/GetCities',
            {
                DistrictID
            }
        );

        setCitiesList(res.data);
    }

    const GetWebsiteProviders = async () => {
        const res = await MerchantPortalAxios.get(
            '/v1/MerchantEnrollment/GetWebsiteProviders',
        );

        setWebProvidersList(res.data);
    }

    const SaveMerchantEnrollmentData = async (payload) => {
        setUploadLoading(true);
        const res = await MerchantPortalAxisFormData.post(
            '/v1/MerchantEnrollment/SaveMerchantEnrollmentData',
            {
                SessionID: sessionStorage.getItem("SessionID"),
                ...payload
            }
        ).then((res) => {
            setUploadLoading(false);
            setResponse(res.data.Payload);
        });
    }

    return {
        CorporateAutoFillData,
        GetEmployeeNames,
        SaveCorporateEnrollmentData,
        GetCategories,
        GetSubCategories,
        GetDistricts,
        GetCities,
        GetWebsiteProviders,
        SaveMerchantEnrollmentData,
        employeesList,
        autofillData,
        uploadLoading,
        categoriesList,
        subCategoriesList,
        districtsList,
        citiesList,
        webProvidersList,
        response
    }

}

export default MerchantEnrollmentAPI;